// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3kobU","tab":"Tabs_tab__BALAt","tabActive":"Tabs_tabActive__MJSE_"};